module.exports = __webpack_public_path__ + "static/media/chess-pawn.04d58a54.png";